import {ReactNode} from 'react';
import {view, css} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';

type Props = {
  children: ReactNode;
  hover?: boolean;
  isOuter?: boolean;
};

const cardStyles = css({
  backgroundColor: 'surface',
  border: css.value('1px solid #D8DEE4'),
  borderRadius: 'xsmall',
  boxShadow: 'base',
  padding: css.value('$space.200'),
  marginBottom: 'small',
});

const outerStyles = css({
  borderRadius: 'medium',
  boxShadow: 'none',
});

// TODO: duplicating tokens.shadow.large due to deprecated Sail version
const hoverStyles = css({
  '&:hover': {
    boxShadow: css.value(
      '0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(48, 49, 61, 0.08)',
    ),
  },
});

export function LightCard({children, hover, isOuter}: Props) {
  const theme = useTheme();

  const styles = [cardStyles];
  if (hover) {
    styles.push(hoverStyles);
  }

  if (isOuter) {
    styles.push(outerStyles);
  }

  return (
    <view.div
      data-testid="card"
      uses={styles}
      css={{
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
    >
      {children}
    </view.div>
  );
}
